import styled from 'styled-components'

export const Select = styled('select')`
  border: 0px;
  padding: 0px;
  width: 100%;
`